import React from 'react';
import { useId } from '@sail/react-aria';
export const LABEL_OPT_OUT_STRING = 'i-am-providing-my-own-label';
export const useInputId = ({ id: propsId, label, outerRef })=>{
    const id = useId(propsId);
    const newRef = React.useRef(null);
    const rootNode = outerRef !== null && outerRef !== void 0 ? outerRef : newRef;
    if (process.env.NODE_ENV !== 'production') {
        // we don't care about rules of hooks here since this condition will never change per env
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useEffect(()=>{
            if (// If the user has opted out of label auto-generation...
            label === LABEL_OPT_OUT_STRING && // ...and the node is mounted...
            (rootNode === null || rootNode === void 0 ? void 0 : rootNode.current) !== null && (rootNode === null || rootNode === void 0 ? void 0 : rootNode.current.isConnected)) {
                var // ...and there's nothing in the DOM that corresponds to our id...
                _rootNode_current_getRootNode;
                if (((_rootNode_current_getRootNode = rootNode.current.getRootNode()) === null || _rootNode_current_getRootNode === void 0 ? void 0 : _rootNode_current_getRootNode.querySelectorAll(`[for='${id}']`).length) === 0 && // ...or the node doesn't have a label as an ancestor...
                rootNode.current.closest('label') === null) {
                    // ...throw an error
                    throw new Error(`You opted out of control auto-labeling for element #${id}, but that element is unlabeled.`);
                }
            }
        }, [
            label,
            id,
            rootNode
        ]);
    }
    return {
        id,
        rootNode
    };
};

//# sourceMappingURL=useInputId.js.map